import produce from "immer"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

const initQidProductDocumentState: types.QidProductDocumentState = {
    documentList: {},
    documentIds: [],

    reloadList: true,
}

const qidProductDocumentReducer = produce((
    draft: types.QidProductDocumentState = initQidProductDocumentState,
    action: ActionTypes = null,
): types.QidProductDocumentState => {
    switch (action.type) {
        case types.QID_PRODUCT_DOCUMENT_LIST:
            draft.documentList = action.documentList
            draft.documentIds = action.documentIds
            return draft

        case types.QID_PRODUCT_DOCUMENT_RELOAD_LIST:
            draft.reloadList = action.value
            return draft

        default:
            return draft
    }
})
export default qidProductDocumentReducer
